<template>
  <a-layout id="app">
    <a-layout-header :style="{
      position: 'fixed',
      zIndex: 1,
      width: '100%',
      userSelect: 'none',
    }">
      <div class="logo">
        <img alt="Logo" src="@/assets/logo.png" style="cursor: pointer" @click="goTo({ name: 'Home' })" />
      </div>
      <a-menu :selectedKeys="$route.meta.menuKeyValue
        ? [$route.meta.menuKeyValue]
        : []
        " :style="{ lineHeight: '64px' }" mode="horizontal" theme="dark">
        <a-menu-item key="1" @click="goTo({ name: 'Home' })">
          Strona główna
        </a-menu-item>
        <a-menu-item key="2" @click="goTo({ name: 'Terms' })">
          Regulamin
        </a-menu-item>
        <a-menu-item key="3" @click="goTo({ name: 'Help' })">
          Pomoc
        </a-menu-item>
        <a-menu-item key="4" @click="goTo({ name: 'Contact' })">
          Kontakt
        </a-menu-item>
        <!-- RIGHT -->
        <a-sub-menu v-if="computedSession.isLoggedIn" key="99" :style="{ float: 'right' }">
          <span slot="title"><a-icon type="user" /><span>Profil</span></span>
          <a-menu-item key="991" @click="$router.push({ name: 'Account' })"> Panel użytkownika</a-menu-item>
          <a-menu-item key="992" @click="logout"> Wyloguj</a-menu-item>
        </a-sub-menu>
        <a-menu-item v-else key="98" :style="{ float: 'right' }" @click="$router.push({ name: 'Login' })">
          <a-button type="primary">
            Zaloguj się
          </a-button>
        </a-menu-item>
        <a-menu-item key="95" :style="{ float: 'right' }">
          <a-spin :style="{
            transform: loadingIndicator ? 'scale(1,1)' : 'scale(0,0)',
            opacity: loadingIndicator ? '1' : '0',
          }" class="loader" />
        </a-menu-item>
      </a-menu>
    </a-layout-header>
    <a-layout-content :style="{
      padding: '0 50px',
      margin: '64px auto',
      width: '100%',
      maxWidth: '1980px',
    }">
      <a-breadcrumb :style="{ margin: '16px 0', userSelect: 'none' }">
        <a-breadcrumb-item>Connect Ark</a-breadcrumb-item>
        <a-breadcrumb-item>{{ $route.meta.title }}</a-breadcrumb-item>
        <a-breadcrumb-item v-if="$route.meta.subtitle !== undefined">{{
          $route.meta.subtitle
          }}
        </a-breadcrumb-item>
      </a-breadcrumb>

      <router-view @loadedView="stopLoadingAnimation" />
    </a-layout-content>
    <a-layout-footer class="footer">
      <p>
        Crafted with<img alt="love" class="with-love" src="@/assets/love.png" />by Togi Media
      </p>
      <p style="opacity: 0.75; font-size: 0.9em">
        <a @click="goTo({ name: 'RODO' })">Obowiązek informacyjny RODO</a>
        &nbsp;&bull;&nbsp;
        <a href="https://tu.kielce.pl/start/uczelnia/rodo/" target="_blank">Inspektor Ochrony Danych</a>
        &nbsp;&bull;&nbsp;
        <a @click="goTo({ name: 'Credits' })">Wykorzystane oprogramowanie</a>
      </p>
    </a-layout-footer>
    <!-- <div v-if="loadingIndicator" :class="'full-page-loader ' + (loadingIndicator ? 'active' : '')">
      <a-row style="height: 100vh; padding-left: 16px; padding-right: 16px;" :gutter="[16, 16]" type="flex" align="middle"
        justify="space-around">
        <a-col :xs="24" :sm="24" :md="18" :lg="14" :xl="12" :xxl="8">
          <a-card>
            <a-result title="Ładowanie danych...">
              <template #icon>
                <a-spin size="large" />
              </template>
</a-result>
</a-card>
</a-col>
</a-row>
</div> -->
  </a-layout>
</template>

<script>
export default {
  data() {
    return {
      loadingIndicator: true,
    };
  },
  beforeCreate() {
    this.$store.dispatch("getUserConnectionDetails");
  },
  mounted() {
    setInterval(() => {
      // Check if user is logged in
      let minutes = (new Date() - new Date(this.computedSession.lastUpdate)) / 1000 / 60
      if (minutes > 1) {
        this.$store.dispatch("getUserConnectionDetails");
      }
      if (!this.computedSession.isLoggedIn && (this.$route.meta.shouldBeLoggedIn !== undefined && this.$route.meta.shouldBeLoggedIn)) {
        this.goTo({ name: 'Logout' })
      }
    }, 5000)
  },
  computed: {
    computedSession: function () {
      return this.$store.getters.getUserConnectionDetails;
    },
  },
  methods: {
    goTo(obj) {
      if (this.$route.path !== obj.path) {
        this.loadingIndicator = true;
        this.$router.push(obj);
      }
    },
    stopLoadingAnimation() {
      this.loadingIndicator = false;
    },
    logout() {
      window.location.href = "/api/identity/logout?next=/account/logout"
    }
  },
};
</script>

<style>
#app {
  min-height: 100vh;
}

#app .logo {
  width: 120px;
  height: 31px;
  margin: 0px 24px 0px 0;
  float: left;
}

#app .logo img {
  width: inherit;
}

.with-love {
  height: 1em;
  margin: 0px 0.5em;
}

.footer {
  text-align: center;
  color: #7d7d7d;
}

.loader {
  -webkit-transition: all 1.5s ease-in-out;
  -moz-transition: all 1.5s ease-in-out;
  -o-transition: all 1.5s ease-in-out;
  transition: all 1.5s ease-in-out;
}

.ant-card,
.ant-layout-header {
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
}

.ant-card {
  border-radius: 12px;
}

.ant-card .ant-card {
  box-shadow: none;
}

.ant-card-actions {
  border-radius: 0px 0px 12px 12px;
}

.no-orphan {
  white-space: nowrap;
}

.full-page-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: #f0f2f5;
  -webkit-transition: all 1.5s ease-in-out;
  -moz-transition: all 1.5s ease-in-out;
  -o-transition: all 1.5s ease-in-out;
  transition: all 1.5s ease-in-out;
  opacity: 0;
}

.full-page-loader.active {
  opacity: 1;
}
</style>
